// Legal texts for ESSENC·IA - Catalan and Spanish
// Spanish texts provided by DABO Consulting (legal team)
// Catalan texts: faithful translation of the Spanish version

const PDF_LINKS = {
  aviso: "/aviso-legal-essencia.pdf",
  privacy: "/politica-privacidad-essencia.pdf",
  cookies: "/politica-cookies-essencia.pdf",
  terms: "/condiciones-generales-essencia.pdf",
};

export const legalPdfs = PDF_LINKS;

export const legalTexts = {
  // =====================================================================
  // 1) AVISO LEGAL
  // =====================================================================
  legalNotice: {
    ca: {
      title: "Avís Legal",
      lastUpdated: "Última actualització: maig 2026",
      pdf: PDF_LINKS.aviso,
      content: `
## 1) Identificació

El present avís legal regula l'ús del lloc web ESSENCIA-APP.COM (en endavant, la WEB), de la qual és titular CRISTINA BAYÉS ESPINET (en endavant, PROPIETÀRIA DE LA WEB).

La PROPIETÀRIA DE LA WEB, en compliment de la Llei 34/2002, d'11 de juliol, de serveis de la societat de la informació i de comerç electrònic, l'informa que:

- **Denominació**: CRISTINA BAYÉS ESPINET
- **Nom comercial**: ESSENC·IA
- **NIF**: 33951406W
- **Domicili social**: PASSATGE SERAFINS Nº 16 1r PIS, ARBÚCIES (GIRONA), C.P. 17401

Per comunicar-se amb nosaltres, posem a la seva disposició diferents mitjans de contacte:

- **Telèfon**: 648 89 43 50
- **Correu electrònic**: hola@essencia-app.com

Totes les notificacions i comunicacions entre els usuaris i la PROPIETÀRIA DE LA WEB es consideraran eficaces, a tots els efectes, quan es realitzin a través de correu postal o qualsevol altre mitjà dels detallats anteriorment.

## 2) Usuaris

L'accés i/o ús d'aquest portal de la PROPIETÀRIA DE LA WEB, creadora del lloc, atribueix la condició d'USUARI, que accepta, des d'aquest accés i/o ús, les Condicions Generals d'Ús aquí reflectides. Aquestes Condicions seran d'aplicació independentment de les Condicions Generals de Contractació que, si s'escau, resultin d'obligat compliment.

## 3) Ús del portal

El lloc web i els seus serveis són d'accés lliure i gratuït. No obstant això, la PROPIETÀRIA DE LA WEB condiciona la utilització d'alguns dels serveis oferts a la prèvia emplenament del formulari corresponent per esdevenir usuari del portal.

L'usuari garanteix l'autenticitat i actualitat de totes les dades que comuniqui a la PROPIETÀRIA DE LA WEB i serà l'únic responsable de les manifestacions falses o inexactes que realitzi.

L'usuari es compromet expressament a fer un ús adequat dels continguts i serveis i a no emprar-los per, entre altres:

a. Difondre continguts delictius, violents, pornogràfics, racistes, xenòfobs, ofensius, d'apologia del terrorisme o, en general, contraris a la llei o a l'ordre públic.
b. Introduir a la xarxa virus informàtics o realitzar actuacions susceptibles d'alterar, espatllar, interrompre o generar errors o danys en els documents electrònics, dades o sistemes físics i lògics de la PROPIETÀRIA DE LA WEB o de terceres persones.
c. Intentar accedir als comptes de correu d'altres usuaris o a àrees restringides dels sistemes informàtics de la PROPIETÀRIA DE LA WEB o de tercers.
d. Vulnerar els drets de propietat intel·lectual o industrial, així com violar la confidencialitat de la informació.
e. Suplantar la identitat d'un altre usuari, de les administracions públiques o d'un tercer.
f. Reproduir, copiar, distribuir, posar a disposició o de qualsevol altra manera comunicar públicament, transformar o modificar els continguts, llevat que es disposi de l'autorització del titular dels drets corresponents.
g. Recollir dades amb finalitat publicitària i remetre publicitat de qualsevol classe sense que hi hagi sol·licitud o consentiment previs.

## 4) Política de privacitat

La PROPIETÀRIA DE LA WEB vol posar en coneixement dels usuaris la política duta a terme respecte al tractament i protecció de les dades de caràcter personal d'aquelles persones que voluntàriament utilitzen els formularis de contacte o accedeixen a la web, que impliquin la comunicació de les seves dades personals.

**A.- Identificació del responsable del tractament.** La PROPIETÀRIA DE LA WEB, amb NIF 33951406W, informa l'usuari de l'existència d'un registre d'activitats automatitzat de dades personals denominat CLIENTS, on es recullen i s'emmagatzemen les dades que l'usuari li comunica per gestionar la seva sol·licitud.

**B.- Actualització de les polítiques.** La PROPIETÀRIA DE LA WEB modificarà, sense avís previ, aquesta política de privacitat sempre que sigui necessari per adequar-la a qualsevol canvi legislatiu, reglamentari, jurisprudencial o administratiu. La nova versió serà publicada a la web.

**C.- Finalitat del registre d'activitats.** El tractament de les dades es realitza amb les finalitats següents: gestionar les sol·licituds de pressupost, contractació i prestació de serveis, atendre comunicacions rebudes i, si s'escau, enviar comunicacions de prospecció comercial sobre eventuals promocions.

**D.- Consentiment.** Quan l'usuari enviï un correu electrònic o una comunicació amb les seves dades personals, estarà donant el seu consentiment lliure, inequívoc, específic, informat i exprés per al tractament d'aquestes dades amb les finalitats establertes anteriorment.

**E.- Destinataris.** La PROPIETÀRIA DE LA WEB únicament té prevista la realització de cessions o comunicacions de dades que en virtut del RGPD (UE 2016/679) i la LOPD-GDD (LO 3/2018) hagi de realitzar per atendre les seves obligacions amb les administracions públiques o organismes directament relacionats.

**F.- Qualitat de les dades.** Cap usuari no pot utilitzar la identitat d'una altra persona ni comunicar les seves dades personals. L'usuari serà l'únic responsable davant de qualsevol dany causat per l'ús de dades personals d'una altra persona o per dades pròpies falses, errònies, no actuals, inadequades o impertinents.

**G.- Drets d'Accés, Rectificació, Limitació, Portabilitat, Cancel·lació, Oposició i Supressió.** L'usuari pot exercir aquests drets, així com presentar reclamació davant l'Autoritat de Control, mitjançant escrit dirigit a la PROPIETÀRIA DE LA WEB a la direcció PASSATGE SERAFINS Nº 16 1r PIS o mitjançant correu a hola@essencia-app.com, adjuntant DNI o targeta d'identitat en ambdós casos.

**H.- Ús de formularis.** En els formularis de contacte on es recullen dades de caràcter personal, l'usuari haurà de consentir expressament i amb caràcter previu, mitjançant la marca de la casella "he llegit i accepto la política de privacitat", l'acceptació d'aquesta política.

**I.- Mesures de seguretat.** La PROPIETÀRIA DE LA WEB ha adoptat les mesures tècniques i organitzatives necessàries per garantir la seguretat de les dades de caràcter personal i evitar la seva alteració, pèrdua o accés no autoritzat, així com el compliment del deure de secret professional.

**J.- Més informació.** Si vol obtenir més informació sobre la nostra política de privacitat, pot consultar la **Política de Privacitat de segona capa** disponible en aquesta mateixa pàgina.

## 5) Propietat intel·lectual i industrial

Queden expressament prohibides la reproducció, la distribució i la comunicació pública, inclosa la modalitat de posada a disposició, de la totalitat o part dels continguts d'aquesta web (textos, fotografies, gràfics, imatges, icones, tecnologia, programari, disseny gràfic i codi font) amb fins comercials i sense l'autorització de la PROPIETÀRIA DE LA WEB.

Totes les marques, noms comercials o signes distintius que apareixen a la web són propietat de la PROPIETÀRIA DE LA WEB.

L'establiment d'un hiperenllaç no implica relacions entre la PROPIETÀRIA DE LA WEB i el propietari del lloc en què s'estableixi.

## 6) Exclusió de garanties i de responsabilitat

El contingut d'aquest lloc web és de caràcter general i té una finalitat merament informativa. La PROPIETÀRIA DE LA WEB exclou, fins on permet l'ordenament jurídic, qualsevol responsabilitat pels danys i perjudicis derivats de:

a. La impossibilitat d'accés al lloc web o la manca de veracitat, exactitud o actualitat dels continguts.
b. La presència de virus o altres elements en els continguts.
c. L'incompliment de les lleis, la bona fe, l'ordre públic o el present avís legal com a conseqüència d'un ús incorrecte del lloc web.

## 7) Modificació de les presents condicions i durada

La PROPIETÀRIA DE LA WEB podrà modificar en qualsevol moment les condicions aquí determinades, que estaran vigents fins que siguin modificades per altres degudament publicades.

## 8) Enllaços

La PROPIETÀRIA DE LA WEB declina qualsevol responsabilitat respecte a la informació que es trobi fora d'aquesta web i no sigui gestionada directament. Els links serveixen exclusivament per informar l'usuari sobre l'existència d'altres fonts.

## 9) Dret d'exclusió

La PROPIETÀRIA DE LA WEB es reserva el dret de denegar o retirar l'accés al portal i/o als serveis oferts, sense necessitat d'avís previ, als usuaris que incompleixin aquestes Condicions Generals d'Ús.

## 10) Generalitats

Qualsevol usuari o tercer que consideri que existeixen fets o circumstàncies que revelin el caràcter il·lícit de l'ús de qualsevol contingut haurà d'enviar una notificació a la PROPIETÀRIA DE LA WEB, identificant-se degudament.

## 11) Publicacions

La informació administrativa facilitada a través del lloc web no substitueix la publicitat legal de les lleis, normatives, plans i actes que hagin de ser publicats formalment als diaris oficials.

## 12) Llei aplicable i jurisdicció

Aquestes condicions es regiran o interpretaran segons la legislació espanyola. El prestador i l'usuari acorden sotmetre qualsevol controvèrsia als Jutjats i Tribunals del domicili de l'usuari. Si l'usuari té domicili fora d'Espanya, ambdues parts renuncien a qualsevol altre fur i se sotmeten als del domicili de la PROPIETÀRIA DE LA WEB.
`
    },
    es: {
      title: "Aviso Legal",
      lastUpdated: "Última actualización: mayo 2026",
      pdf: PDF_LINKS.aviso,
      content: `
## 1) Identificación

El presente aviso legal regula el uso del sitio web ESSENCIA-APP.COM (en adelante, LA WEB), del que es titular CRISTINA BAYÉS ESPINET (en adelante, PROPIETARIO DE LA WEB).

El PROPIETARIO DE LA WEB, en cumplimiento de la Ley 34/2002, de 11 de julio, de servicios de la sociedad de la información y de comercio electrónico, le informa que:

- **Denominación**: CRISTINA BAYÉS ESPINET
- **Nombre comercial**: ESSENC·IA
- **NIF**: 33951406W
- **Domicilio social**: PASSATGE SERAFINS Nº 16 1º PISO, ARBUCIES (GIRONA), C.P. 17401

Para comunicarse con nosotros ponemos a su disposición los siguientes medios de contacto:

- **Teléfono**: 648 89 43 50
- **Correo electrónico**: hola@essencia-app.com

Todas las notificaciones y comunicaciones entre los usuarios y el PROPIETARIO DE LA WEB se considerarán eficaces, a todos los efectos, cuando se realicen a través de correo postal o cualquier otro medio de los detallados anteriormente.

## 2) Usuarios

El acceso y/o uso de este portal del PROPIETARIO DE LA WEB, creadora del sitio, atribuye la condición de USUARIO, al que acepta, desde dicho acceso y/o uso, las Condiciones Generales de Uso aquí reflejadas. Las citadas Condiciones serán de aplicación independientemente de las Condiciones Generales de Contratación que en su caso resulten de obligado cumplimiento.

## 3) Uso del portal

El sitio web y sus servicios son de acceso libre y gratuito; no obstante, el PROPIETARIO DE LA WEB condiciona la utilización de algunos de los servicios ofrecidos en su web a la previa cumplimentación del correspondiente formulario para convertirse en usuario del portal.

El usuario garantiza la autenticidad y actualidad de todos aquellos datos que comunique al PROPIETARIO DE LA WEB y será el único responsable de las manifestaciones falsas o inexactas que realice.

El usuario se compromete expresamente a hacer un uso adecuado de los contenidos y servicios y a no emplearlos para, entre otros:

a. Difundir contenidos delictivos, violentos, pornográficos, racistas, xenófobos, ofensivos, de apología del terrorismo o, en general, contrarios a la ley o al orden público.
b. Introducir en la red virus informáticos o realizar actuaciones susceptibles de alterar, estropear, interrumpir o generar errores o daños en los documentos electrónicos, datos o sistemas físicos y lógicos del PROPIETARIO DE LA WEB o de terceras personas.
c. Intentar acceder a las cuentas de correo electrónico de otros usuarios o a áreas restringidas de los sistemas informáticos.
d. Vulnerar los derechos de propiedad intelectual o industrial, así como violar la confidencialidad de la información.
e. Suplantar la identidad de otro usuario, de las administraciones públicas o de un tercero.
f. Reproducir, copiar, distribuir, poner a disposición o de cualquier otra forma comunicar públicamente, transformar o modificar los contenidos, a menos que se cuente con la autorización del titular de los correspondientes derechos.
g. Recabar datos con finalidad publicitaria y remitir publicidad de cualquier clase y comunicaciones con fines de venta sin que medie su previa solicitud o consentimiento.

## 4) Política de privacidad

El PROPIETARIO DE LA WEB quiere poner en conocimiento de los usuarios la política llevada a cabo respecto al tratamiento y protección de los datos de carácter personal de aquellas personas que voluntariamente utilizan los formularios de contacto, así como el acceso a su página propia, que impliquen la comunicación de sus datos personales.

**A.- Identificación del responsable del tratamiento.** El PROPIETARIO DE LA WEB, provista de NIF 33951406W, informa al usuario de la existencia de un registro de actividades automatizado de datos personales denominado CLIENTES, donde se recogen y almacenan los datos personales que el usuario le comunica a fin de gestionar su solicitud.

**B.- Actualización de las políticas.** El PROPIETARIO DE LA WEB modificará, sin previo aviso, la presente política de privacidad siempre que sea necesario para adecuar la misma a cualquier cambio legislativo, reglamentario, jurisprudencial o administrativo. La nueva versión será publicada en la web.

**C.- Finalidad del registro de actividades.** El tratamiento de los datos se realiza con las siguientes finalidades: llevar a cabo todas las gestiones relacionadas con la elaboración de presupuestos, contratación y prestación de servicios, atender las comunicaciones recibidas y, en su caso, las de prospección comercial sobre eventuales promociones.

**D.- Consentimiento.** Cuando el usuario envíe un correo electrónico o una comunicación al PROPIETARIO DE LA WEB indicando datos personales, dicho usuario estará dando su consentimiento libre, inequívoco, específico, informado y expreso para el tratamiento de sus datos personales con las finalidades establecidas anteriormente.

**E.- Destinatarios.** El PROPIETARIO DE LA WEB únicamente tiene prevista la realización de cesiones o comunicaciones de datos que en razón al RGPD (UE 2016/679) y la LOPD-GDD (LO 3/2018) deba realizar para atender sus obligaciones con las Administraciones Públicas u organismos directamente relacionados.

**F.- Calidad de los datos.** Ningún usuario puede utilizar la identidad de otra persona ni comunicar sus datos personales. El usuario será el único responsable frente a cualquier daño causado a terceros o al PROPIETARIO DE LA WEB por el uso de datos personales de otra persona o por sus propios datos personales cuando sean falsos, erróneos, no actuales, inadecuados o impertinentes.

**G.- Derechos de Acceso, Rectificación, Limitación del tratamiento, Portabilidad, Cancelación, Oposición del tratamiento y Supresión.** El usuario puede ejercer estos derechos, así como presentar reclamación ante la Autoridad de Control, mediante escrito dirigido al PROPIETARIO DE LA WEB en la dirección PASSATGE SERAFINS Nº 16 1º PISO o mediante correo a hola@essencia-app.com, adjuntando DNI o tarjeta de identidad en ambos casos.

**H.- Uso de formularios para la recogida de datos personales.** En los formularios de contacto donde se recogen datos de carácter personal, el usuario deberá consentir de manera expresa y previa, mediante la cumplimentación del check "he leído y acepto la política de privacidad", la aceptación de dicha política. Si el check no fuere marcado, no se realizará el envío de los datos.

**I.- Medidas de seguridad.** El PROPIETARIO DE LA WEB ha adoptado las medidas técnicas y organizativas necesarias para garantizar la seguridad de los datos de carácter personal y evitar su alteración, pérdida o acceso no autorizado, así como el cumplimiento del deber de secreto profesional.

**J.- Más información sobre política de privacidad.** Si quiere obtener mayor información sobre nuestra política de privacidad, puede consultar la **Política de Privacidad de segunda capa** disponible en esta misma página.

## 5) Propiedad intelectual e industrial

Quedan expresamente prohibidas la reproducción, la distribución y la comunicación pública, incluida su modalidad de puesta a disposición, de la totalidad o parte de los contenidos de esta web (textos, fotografías, gráficos, imágenes, iconos, tecnología, software, así como su diseño gráfico y códigos fuente) con fines comerciales, sin la autorización del PROPIETARIO DE LA WEB.

Todas las marcas, nombres comerciales o signos distintivos que aparecen en el sitio web son propiedad del PROPIETARIO DE LA WEB.

El establecimiento de un hiperenlace no implica relaciones entre el PROPIETARIO DE LA WEB y el propietario del sitio web en el que se establezca.

## 6) Exclusión de garantías y de responsabilidad

El contenido del presente sitio web es de carácter general y tiene una finalidad meramente informativa. El PROPIETARIO DE LA WEB excluye, hasta donde permite el ordenamiento jurídico, cualquier responsabilidad por los daños y perjuicios derivados de:

a. La imposibilidad de acceso al sitio web o la falta de veracidad, exactitud o actualidad de los contenidos.
b. La presencia de virus o de otros elementos en los contenidos.
c. El incumplimiento de las leyes, la buena fe, el orden público o el presente aviso legal como consecuencia del uso incorrecto del sitio web.

## 7) Modificación de las presentes condiciones y duración

El PROPIETARIO DE LA WEB podrá modificar en cualquier momento las condiciones aquí determinadas, que estarán vigentes hasta que sean modificadas por otras debidamente publicadas.

## 8) Enlaces

El PROPIETARIO DE LA WEB declina cualquier responsabilidad respecto a la información que se halle fuera de esta web y no sea gestionada directamente. Los links de esta web sirven exclusivamente para informar al usuario sobre la existencia de otras fuentes.

## 9) Derecho de exclusión

El PROPIETARIO DE LA WEB se reserva el derecho a denegar o retirar el acceso al portal y/o a los servicios ofrecidos, sin necesidad de preaviso, a aquellos usuarios que incumplan las presentes Condiciones Generales de Uso.

## 10) Generalidades

Cualquier usuario o tercero que considere que existen hechos o circunstancias que revelen el carácter ilícito de la utilización de cualquier contenido deberá enviar una notificación al PROPIETARIO DE LA WEB, identificándose debidamente.

## 11) Publicaciones

La información administrativa facilitada a través del sitio web no sustituye la publicidad legal de las leyes, normativas, planes y actos que tengan que ser publicados formalmente en los diarios oficiales.

## 12) Ley aplicable y jurisdicción

Estas condiciones se regirán o interpretarán conforme a la legislación española. El prestador y el usuario acuerdan someter cualquier controversia a los Juzgados y Tribunales del domicilio del usuario. Si el usuario tiene su domicilio fuera de España, ambas partes renuncian expresamente a cualquier otro fuero y se someten a los del domicilio del PROPIETARIO DE LA WEB.
`
    }
  },

  // =====================================================================
  // 2) POLÍTICA DE PRIVACIDAD (segunda capa)
  // =====================================================================
  privacyPolicy: {
    ca: {
      title: "Política de Privacitat",
      lastUpdated: "Última actualització: maig 2026",
      pdf: PDF_LINKS.privacy,
      content: `
La privacitat és de gran importància per a CRISTINA BAYÉS ESPINET i volem mantenir una actitud oberta i transparent en el tractament de les seves dades personals.

Per això, disposem d'una política que estableix com es tracten i es protegeixen les seves dades personals.

## Qui és el responsable del tractament de les seves dades?

**CRISTINA BAYÉS ESPINET** amb NIF: **33951406W**

- **Domicili social**: PASSATGE SERAFINS Nº 16 1r PIS, ARBÚCIES (GIRONA), C.P. 17401
- **Correu electrònic de contacte**: hola@essencia-app.com

## Amb quina finalitat tractem les seves dades personals?

CRISTINA BAYÉS ESPINET tracta la informació que faciliten les persones interessades amb la finalitat de realitzar la gestió administrativa, comptable i fiscal dels serveis sol·licitats, així com enviar comunicacions comercials sobre els nostres productes i serveis, per al consentiment dels quals vostè hagi prestat la seva autorització.

## Per quant de temps conservarem les seves dades?

Les dades es conservaran mentre es mantingui la relació comercial i, si s'escau, durant els anys necessaris per complir les obligacions legals que resultin d'aplicació.

## Quina és la legitimació per al tractament de les seves dades?

La base legal per al tractament de les seves dades:

- **Execució d'un contracte**: prestació dels serveis sol·licitats.
- **Consentiment de l'interessat**: enviament de comunicacions comercials.

## A quins destinataris es comunicaran les seves dades?

Únicament se cediran les seves dades per donar compliment a obligacions legals.

## Transferències de dades a tercers països

No estan previstes transferències de dades a tercers països.

## Quins són els seus drets quan ens facilita les seves dades?

Qualsevol persona té dret a obtenir confirmació sobre si CRISTINA BAYÉS ESPINET està tractant dades personals que la concerneixin.

Les persones interessades tenen dret a:

- Accedir a les seves dades personals.
- Sol·licitar la rectificació de les dades inexactes.
- Sol·licitar la seva supressió quan, entre altres motius, les dades ja no siguin necessàries per a les finalitats per a les quals van ser recollides.
- Sol·licitar la limitació del tractament en determinades circumstàncies. En aquest cas, només les conservarem per a l'exercici o la defensa de reclamacions.
- Oposar-se al tratament per motius relacionats amb la seva situació particular. En aquest cas, CRISTINA BAYÉS ESPINET deixarà de tractar les dades, llevat de motius legítims imperiosos o l'exercici o la defensa de possibles reclamacions.

Podrà exercitar materialment els seus drets adreçant-se a la direcció de correu electrònic del responsable del tractament adjuntant còpia del seu DNI o document d'identitat.

Si ha atorgat el seu consentiment per a alguna finalitat concreta, té dret a retirar-lo en qualsevol moment, sense que això afecti la licitud del tractament basat en el consentiment previ a la seva retirada.

En cas que senti vulnerats els seus drets pel que fa a la protecció de les seves dades personals, especialment quan no hagi obtingut satisfacció en l'exercici dels seus drets, pot presentar una reclamació davant l'Autoritat de Control en matèria de Protecció de Dades competent a través del seu lloc web: **www.aepd.es**.

## Com hem obtingut les seves dades?

Les dades personals que tracta CRISTINA BAYÉS ESPINET han estat directament proporcionades per l'interessat.

Les categories de dades que es tracten són:

- Dades identificatives
- Adreces postals i electròniques
- Informació comercial
`
    },
    es: {
      title: "Política de Privacidad",
      lastUpdated: "Última actualización: mayo 2026",
      pdf: PDF_LINKS.privacy,
      content: `
La privacidad es de gran importancia para CRISTINA BAYÉS ESPINET y queremos mantener una actitud abierta y transparente al tratar sus datos personales.

Por lo tanto, disponemos de una política que establece cómo se tratan y protegen sus datos personales.

## ¿Quién es el responsable del tratamiento de sus datos?

**CRISTINA BAYÉS ESPINET** con NIF: **33951406W**

- **Domicilio social**: PASSATGE SERAFINS Nº 16 1º PISO, ARBUCIES (GIRONA), C.P. 17401
- **Correo electrónico de contacto**: hola@essencia-app.com

## ¿Con qué finalidad tratamos sus datos personales?

CRISTINA BAYÉS ESPINET trata la información que le facilitan las personas interesadas con el fin de realizar la gestión administrativa, contable y fiscal de los servicios solicitados, así como enviar comunicaciones comerciales sobre nuestros productos y servicios, para cuyo consentimiento usted haya prestado su autorización.

## ¿Por cuánto tiempo conservaremos sus datos?

Los datos se conservarán mientras se mantenga la relación comercial y, en su caso, durante los años necesarios para cumplir con las obligaciones legales que resulten de aplicación.

## ¿Cuál es la legitimación para el tratamiento de sus datos?

Le indicamos la base legal para el tratamiento de sus datos:

- **Ejecución de un contrato**: prestación de los servicios solicitados.
- **Consentimiento del interesado**: envío de comunicaciones comerciales.

## ¿A qué destinatarios se comunicarán sus datos?

Únicamente se cederán sus datos para dar cumplimiento a obligaciones legales.

## Transferencias de datos a terceros países

No están previstas transferencias de datos a terceros países.

## ¿Cuáles son sus derechos cuando nos facilita sus datos?

Cualquier persona tiene derecho a obtener confirmación sobre si CRISTINA BAYÉS ESPINET está tratando datos personales que les conciernan, o no.

Las personas interesadas tienen derecho a:

- Acceder a sus datos personales.
- Solicitar la rectificación de los datos inexactos.
- Solicitar su supresión cuando, entre otros motivos, los datos ya no sean necesarios para los fines para los que fueron recogidos.
- Solicitar la limitación del tratamiento en determinadas circunstancias. En este caso, únicamente los conservaremos para el ejercicio o la defensa de reclamaciones.
- Oponerse al tratamiento por motivos relacionados con su situación particular. En este caso, CRISTINA BAYÉS ESPINET dejará de tratar los datos, salvo por motivos legítimos imperiosos, o el ejercicio o la defensa de posibles reclamaciones.

Podrá ejercitar materialmente sus derechos dirigiéndose a la dirección de correo electrónico del responsable del tratamiento adjuntando copia de su DNI o documento de identidad.

Si ha otorgado su consentimiento para alguna finalidad concreta, tiene derecho a retirar el consentimiento otorgado en cualquier momento, sin que ello afecte a la licitud del tratamiento basado en el consentimiento previo a su retirada.

En caso de que sienta vulnerados sus derechos en lo concerniente a la protección de sus datos personales, especialmente cuando no haya obtenido satisfacción en el ejercicio de sus derechos, puede presentar una reclamación ante la Autoridad de Control en materia de Protección de Datos competente a través de su sitio web: **www.aepd.es**.

## ¿Cómo hemos obtenido sus datos?

Los datos personales que trata CRISTINA BAYÉS ESPINET han sido directamente proporcionados por el interesado.

Las categorías de datos que se tratan son:

- Datos identificativos
- Direcciones postales y electrónicas
- Información comercial
`
    }
  },

  // =====================================================================
  // 3) POLÍTICA DE COOKIES
  // =====================================================================
  cookiesPolicy: {
    ca: {
      title: "Política de Cookies",
      lastUpdated: "Última actualització: maig 2026",
      pdf: PDF_LINKS.cookies,
      content: `
## Què són les cookies?

Una cookie és un fitxer que es descarrega a l'ordinador o dispositiu de l'usuari quan accedeix a determinades pàgines web. Les cookies permeten a una pàgina web, entre altres coses, emmagatzemar i recuperar informació sobre hàbits de navegació d'un usuari o del seu equip i, depenent de la informació que continguin i la manera com s'utilitzi l'equip, poden utilitzar-se per reconèixer l'usuari anònim.

Les cookies s'associen únicament a un usuari anònim i el seu ordinador, i no proporcionen referències que permetin deduir dades personals de l'usuari.

En el cas d'usuaris registrats que iniciïn sessió, podran beneficiar-se de serveis més personalitzats i orientats al seu perfil, gràcies a la combinació de les dades emmagatzemades a les cookies amb les dades personals utilitzades en el moment del seu registre. Aquests usuaris autoritzen expressament l'ús d'aquesta informació amb la finalitat indicada, sens perjudici del seu dret a rebutjar o deshabilitar l'ús de cookies.

## Tipologia, finalitat i funcionament de les cookies en general

### 1. Tipus de cookies segons el termini de temps que romanen activades

- **Cookies de sessió**: dissenyades per recollir i emmagatzemar dades mentre l'usuari accedeix a una pàgina web. S'utilitzen per emmagatzemar informació que només interessa conservar per a la prestació del servei sol·licitat en una sola ocasió.
- **Cookies persistents**: les dades segueixen emmagatzemades al terminal i poden ser accedides i tractades durant un període definit pel responsable de la cookie, que pot anar d'uns minuts a diversos anys.

### 2. Tipus de cookies segons l'entitat que les gestiona

- **Cookies pròpies**: s'envien al terminal de l'usuari des d'un equip o domini gestionat pel propi editor i des del qual es presta el servei sol·licitat.
- **Cookies de tercers**: s'envien des d'un equip o domini gestionat per una altra entitat que tracta les dades obtingudes.

### 3. Tipus de cookies segons la seva finalitat

- **Cookies tècniques**: permeten la navegació i la utilització dels diferents serveis (controlar el tràfic, identificar la sessió, accedir a parts d'accés restringit, recordar elements d'una comanda, utilitzar elements de seguretat durant la navegació, etc.).
- **Cookies de personalització**: permeten accedir al servei amb característiques predefinides segons criteris com l'idioma, el navegador, la configuració regional, etc.
- **Cookies d'anàlisi**: permeten el seguiment i anàlisi del comportament dels usuaris dels llocs web. La informació recollida s'utilitza per mesurar l'activitat i elaborar perfils de navegació amb la finalitat d'introduir millores.
- **Cookies publicitàries**: permeten la gestió dels espais publicitaris en funció de criteris com el contingut editat o la freqüència en què es mostren els anuncis.
- **Cookies de publicitat comportamental**: emmagatzemen informació del comportament dels usuaris obtinguda a través de l'observació continuada dels seus hàbits de navegació, per mostrar publicitat ajustada al perfil.

## Consentiment i autorització per a l'ús de cookies

En accedir a aquest lloc web per primera vegada se l'informa de la utilització de les cookies i pot consultar aquesta política mitjançant aquest enllaç. Si vostè consenteix la utilització de cookies, continua navegant o fa clic en algun enllaç, s'entendrà que ha consentit la nostra política de cookies i, per tant, l'acceptació per a la instal·lació d'aquestes al seu equip o dispositiu, excepte en la mesura que hagi modificat la configuració del seu navegador per rebutjar-ne la utilització.

## Quins tipus de cookies utilitza aquesta pàgina web?

Definició, identificació i finalitat de les cookies d'aquesta Web no exceptuades per la LSSI:

- **Cookies d'anàlisi**: ens permeten quantificar el nombre d'usuaris i així mesurar i analitzar estadísticament la utilització del servei. Analitzem la navegació per millorar l'oferta.
- **Cookies publicitàries**: ens permeten gestionar de la forma més eficaç possible l'oferta dels espais publicitaris, adequant el contingut al servei sol·licitat.

### Quadre d'identificació de les cookies i la seva finalitat

| Cookie | Tipus | Editor | Propòsit |
|---|---|---|---|
| __CF_BM | Tercers | hcaptcha.com | Distingir entre humans i bots; elaborar informes vàlids sobre l'ús de la web. |
| _GA | Pròpia | essencia-app.com | Identificador únic de client; control de visites úniques, dades d'usuaris, campanyes. |
| _GA_NGZB1RKKHP | Pròpia | essencia-app.com | Google Analytics — anàlisi de comportament. |
| DMN_CHK_019DD04A-B4B7-7584-A615-1FC7B5C0AD86 | Pròpia | essencia-app.com | Comprovació de domini. |
| CF_CLEARANCE | Pròpia | essencia-app.com | Maximitzar recursos de xarxa, administrar trànsit i protegir el lloc web del trànsit maliciós. |
| PH_PHC_…_POSTHOG | Pròpia | essencia-app.com | Gestió de sessions, seguiment o personalització. Emmagatzemen petites peces de dades al navegador per millorar l'experiència. |

**Nota**: Les cookies "Pròpies" són utilitzades només per la titular d'aquesta web. Les "De tercers" són utilitzades pel prestador del servei detallat al quadre.

## Configuració del navegador per a la revocació i retirada del consentiment

CRISTINA BAYÉS ESPINET recorda als seus usuaris que l'ús de cookies podrà estar subjecte a la seva acceptació durant la instal·lació o actualització del navegador utilitzat. Aquesta acceptació pot ser revocada mitjançant les opcions de configuració de contingut i privacitat disponibles al navegador:

- **Firefox**: [https://support.mozilla.org/es/kb/habilitar-y-deshabilitar-cookies-sitios-web-rastrear-preferencias](https://support.mozilla.org/es/kb/habilitar-y-deshabilitar-cookies-sitios-web-rastrear-preferencias)
- **Chrome**: [https://support.google.com/chrome/answer/95647](https://support.google.com/chrome/answer/95647)
- **Explorer**: [https://support.microsoft.com/es-es/help/17442/](https://support.microsoft.com/es-es/help/17442/)
- **Safari**: [https://support.apple.com/es-es/guide/safari/sfri11471/mac](https://support.apple.com/es-es/guide/safari/sfri11471/mac)
- **Opera**: [https://help.opera.com/en/latest/web-preferences/](https://help.opera.com/en/latest/web-preferences/)
- **Altres navegadors**: consulteu la documentació del navegador instal·lat.

Si l'usuari desitja més informació sobre com revocar el consentiment o sobre el procediment per deshabilitar les cookies, pot contactar amb CRISTINA BAYÉS ESPINET a hola@essencia-app.com, indicant a l'assumpte "Política de Cookies".

## Canvis en la política de Privacitat / Cookies

La web pot modificar aquesta Política de Cookies en funció d'exigències legislatives, reglamentàries o per adaptar-la a les instruccions dictades per l'Agència Espanyola de Protecció de Dades. Per això, es recomana als usuaris que la visitin periòdicament. Quan es produeixin canvis significatius, es comunicaran als usuaris mitjançant la web ESSENCIA-APP.COM.
`
    },
    es: {
      title: "Política de Cookies",
      lastUpdated: "Última actualización: mayo 2026",
      pdf: PDF_LINKS.cookies,
      content: `
## ¿Qué son las cookies?

Una cookie es un fichero que se descarga en su ordenador al acceder a determinadas páginas web. Las cookies permiten a una página web, entre otras cosas, almacenar y recuperar información sobre hábitos de navegación de un usuario o de su equipo y, dependiendo de la información que contengan y de la forma en que utilice su equipo, pueden utilizarse para reconocer al usuario anónimo.

Las cookies se asocian únicamente a un usuario anónimo y a su ordenador, y no proporcionan referencias que permitan deducir datos personales del usuario.

En el caso de usuarios registrados que inicien sesión, podrán beneficiarse de unos servicios más personalizados y orientados a su perfil, gracias a la combinación de los datos almacenados en las cookies con los datos personales utilizados en el momento de su registro. Dichos usuarios autorizan expresamente el uso de esta información con la finalidad indicada, sin perjuicio de su derecho a rechazar o deshabilitar el uso de cookies.

## Tipología, finalidad y funcionamiento de las cookies en general

### 1. Tipos de cookies según el plazo de tiempo que permanecen activadas

- **Cookies de sesión**: diseñadas para recabar y almacenar datos mientras el usuario accede a una página web. Se suelen emplear para almacenar información que solo interesa conservar para la prestación del servicio solicitado en una sola ocasión.
- **Cookies persistentes**: los datos siguen almacenados en el terminal y pueden ser accedidos y tratados durante un periodo definido por el responsable de la cookie, que puede ir de unos minutos a varios años.

### 2. Tipos de cookies según la entidad que las gestione

- **Cookies propias**: se envían al equipo terminal del usuario desde un equipo o dominio gestionado por el propio editor y desde el que se presta el servicio solicitado.
- **Cookies de tercero**: se envían desde un equipo o dominio gestionado por otra entidad que trata los datos obtenidos.

### 3. Tipos de cookies según su finalidad

- **Cookies técnicas**: permiten la navegación y la utilización de los diferentes servicios (controlar el tráfico, identificar la sesión, acceder a partes de acceso restringido, recordar elementos de un pedido, utilizar elementos de seguridad durante la navegación, etc.).
- **Cookies de personalización**: permiten acceder al servicio con características predefinidas según criterios como el idioma, el navegador, la configuración regional, etc.
- **Cookies de análisis**: permiten el seguimiento y análisis del comportamiento de los usuarios de los sitios web. La información recogida se utiliza para medir la actividad y elaborar perfiles de navegación con la finalidad de introducir mejoras.
- **Cookies publicitarias**: permiten la gestión de los espacios publicitarios en función de criterios como el contenido editado o la frecuencia en la que se muestran los anuncios.
- **Cookies de publicidad comportamental**: almacenan información del comportamiento de los usuarios obtenida a través de la observación continuada de sus hábitos de navegación, para mostrar publicidad ajustada al perfil.

## Consentimiento y autorización para el uso de cookies

Al acceder a este sitio web por primera vez, se le informa de la utilización de las cookies y puede consultar esta política mediante este enlace. Si usted consiente la utilización de cookies, continúa navegando o hace clic en algún link, se entenderá que ha consentido nuestra política de cookies y, por tanto, la aceptación para la instalación de las mismas en su equipo o dispositivo, excepto en la medida en que haya modificado la configuración de su navegador para rechazar su utilización.

## ¿Qué tipos de cookies utiliza esta página web?

Definición, identificación y finalidad de las cookies de esta Web no exceptuadas por la LSSI:

- **Cookies de análisis**: nos permiten cuantificar el número de usuarios y así realizar la medición y análisis estadístico de la utilización del servicio. Analizamos su navegación para mejorar la oferta.
- **Cookies publicitarias**: nos permiten gestionar de la forma más eficaz posible la oferta de los espacios publicitarios, adecuando el contenido del anuncio al servicio solicitado.

### Cuadro de identificación de las cookies y su finalidad

| Cookie | Tipo | Editor | Propósito |
|---|---|---|---|
| __CF_BM | Terceros | hcaptcha.com | Distinguir entre humanos y bots; elaborar informes válidos sobre el uso de la web. |
| _GA | Propia | essencia-app.com | Identificador único de cliente; control de visitas únicas, datos de usuarios, campañas. |
| _GA_NGZB1RKKHP | Propia | essencia-app.com | Google Analytics — análisis de comportamiento. |
| DMN_CHK_019DD04A-B4B7-7584-A615-1FC7B5C0AD86 | Propia | essencia-app.com | Comprobación de dominio. |
| CF_CLEARANCE | Propia | essencia-app.com | Maximizar los recursos de red, administrar el tráfico y proteger los sitios web del tráfico malicioso. |
| PH_PHC_…_POSTHOG | Propia | essencia-app.com | Gestión de sesiones, seguimiento o personalización. Almacenan pequeñas piezas de datos en el navegador para mejorar la experiencia. |

**Nota**: las cookies "Propias" son utilizadas solo por la titular de esta web. Las "De terceros" son utilizadas por el prestador del servicio detallado en el cuadro.

## Configuración del navegador para la revocación y retirada del consentimiento

CRISTINA BAYÉS ESPINET recuerda a sus usuarios que el uso de cookies podrá estar sujeto a su aceptación durante la instalación o actualización del navegador utilizado. Esta aceptación podrá ser revocada mediante las opciones de configuración de contenidos y privacidad disponibles en el navegador:

- **Firefox**: [https://support.mozilla.org/es/kb/habilitar-y-deshabilitar-cookies-sitios-web-rastrear-preferencias](https://support.mozilla.org/es/kb/habilitar-y-deshabilitar-cookies-sitios-web-rastrear-preferencias)
- **Chrome**: [https://support.google.com/chrome/answer/95647](https://support.google.com/chrome/answer/95647)
- **Explorer**: [https://support.microsoft.com/es-es/help/17442/](https://support.microsoft.com/es-es/help/17442/)
- **Safari**: [https://support.apple.com/es-es/guide/safari/sfri11471/mac](https://support.apple.com/es-es/guide/safari/sfri11471/mac)
- **Opera**: [https://help.opera.com/en/latest/web-preferences/](https://help.opera.com/en/latest/web-preferences/)
- **Otros navegadores**: consulte la documentación del navegador instalado.

Si el usuario desea más información sobre cómo revocar el consentimiento o sobre el procedimiento para deshabilitar las cookies, puede contactar con CRISTINA BAYÉS ESPINET en hola@essencia-app.com, indicando en el asunto "Política de Cookies".

## Cambios en la política de Privacidad / Cookies

La web puede modificar esta Política de Cookies en función de exigencias legislativas, reglamentarias o para adaptar dicha política a las instrucciones dictadas por la Agencia Española de Protección de Datos. Por ello, se aconseja a los usuarios que la visiten periódicamente. Cuando se produzcan cambios significativos, se comunicarán a los usuarios mediante la web ESSENCIA-APP.COM.
`
    }
  },

  // =====================================================================
  // 4) CONDICIONES GENERALES DE CONTRATACIÓN (Termes i Condicions)
  // =====================================================================
  termsAndConditions: {
    ca: {
      title: "Condicions Generals de Contractació",
      lastUpdated: "Última actualització: maig 2026",
      pdf: PDF_LINKS.terms,
      content: `
## 1r.- Marc legal

En compliment de la normativa vigent, l'entitat CRISTINA BAYÉS ESPINET, que opera a través d'internet des del present lloc ESSENCIA-APP.COM, detalla a continuació les condicions generals de contractació dels productes i/o serveis oferts i dels quals es deriven els drets i obligacions de les parts.

## 2n.- Identificació

Les presents Condicions Generals de Contractació (en endavant, "Condicions") regulen la relació entre CRISTINA BAYÉS ESPINET (en endavant, el "Prestador") i els clients (en endavant, l'"Usuari"), relatives a totes les transaccions realitzades a través d'aquest portal online.

### 2.1.- Empresa Oferent

- **Denominació**: CRISTINA BAYÉS ESPINET
- **Nom comercial**: ESSENC·IA
- **NIF**: 33951406W
- **Domicili**: PASSATGE SERAFINS Nº 16 1r PIS
- **Població**: ARBÚCIES
- **Província**: GIRONA
- **C.P.**: 17401
- **Telèfon**: 648 89 43 50
- **Correu electrònic**: hola@essencia-app.com

### 2.2.- L'Usuari

S'entendrà per usuari o client l'internauta que adquireix aquesta condició mitjançant el seu registre al lloc, utilitzant un formulari, i a qui s'assignen unes claus d'usuari i contrasenya. L'usuari és responsable de la seva custòdia i de la veracitat de les dades personals facilitades.

## 3r.- Acceptació

Mitjançant l'acceptació de les presents Condicions, l'Usuari declara:

1. Que és una persona amb capacitat per contractar segons la normativa vigent.
2. Que ha llegit i accepta les presents Condicions.

## 4t.- Disponibilitat

L'Usuari tindrà accés sempre, amb caràcter previ a l'inici del procediment de contractació, a les condicions, que podran ser emmagatzemades i/o reproduïdes en un suport durador.

## 5è.- Validesa o durada

El període de validesa de les presents Condicions serà el temps que aquestes romanguin publicades al lloc i resultaran d'aplicació des del moment en què l'Usuari faci ús del lloc i/o procedeixi a la contractació/subscripció del producte.

## 6è.- Modificacions

El prestador es reserva el dret de modificar unilateralment aquestes Condicions, sense que això pugui afectar els béns o promocions adquirits prèviament a la modificació per part de l'Usuari.

L'Usuari es compromet a llegir atentament les condicions de contractació cada vegada que contracti un producte, atès que poden haver estat modificades.

## 7è.- Nul·litat

Si qualsevol clàusula d'aquestes Condicions fos declarada total o parcialment nul·la o ineficaç, aquesta nul·litat afectarà només aquesta disposició, subsistint la resta de les Condicions.

## 8è.- Objecte del contracte

El present contracte té per objecte regular la relació contractual de compravenda nascuda entre el prestador i l'usuari en el moment en què aquest accepta la compra durant el procés de contractació online.

La relació contractual de subscripció comporta l'accés a un producte d'autoconeixement emocional amb intel·ligència artificial, a canvi d'un preu determinat i públicament exposat a través del lloc.

## 9è.- Registre d'usuaris

L'Usuari pot registrar-se a essencia-app.com fent clic a "Crear Compte". Per fer-ho, introduirà dades personals obligatòries (Nom, Email, Contrasenya de mínim 6 caràcters, Idioma preferit). Seguidament haurà d'acceptar els termes i condicions i la política de privacitat, i de forma opcional l'acceptació d'enviament de comunicacions comercials.

L'usuari seleccionarà un nom d'usuari i una contrasenya, comprometent-se a fer-ne un ús diligent i a no posar-los a disposició de tercers.

L'usuari no podrà triar com a nom d'usuari paraules que puguin confondre altres usuaris ni expressions malsonants, injurioses o contràries a la moral i bons costums.

El sistema de registre envia un missatge de benvinguda a l'email amb un enllaç de verificació que caduca en 24h. Seguidament l'usuari té accés complet a l'aplicació amb un període de prova gratuït de **7 dies**.

## 10è.- Àmbit geogràfic

ESSENCIA-APP.COM opera sense restriccions geogràfiques. La utilització d'ESSENCIA-APP.COM es considera efectuada a Espanya, subjecta a les lleis i normes espanyoles vigents.

## 11è.- Informació de productes

El Prestador para gran atenció a la informació relativa a les característiques del seu producte mitjançant descripcions detallades de cada funcionalitat. L'usuari té opció d'explorar el contingut durant els 7 primers dies de prova gratuïta.

## 12è.- Impostos, moneda

De conformitat amb la normativa vigent, tota compra/subscripció estarà subjecta a l'Impost sobre el Valor Afegit (IVA). Els preus inclouen l'IVA i s'expressen en euros (€).

## 13è.- Llengua del contracte

El procediment de contractació i la informació precontractual estan disponibles en **català i castellà**.

## 14è.- Passos del procés de contractació/subscripció

### 14.1.- Registre
Un cop registrat, l'usuari pot entrar al seu perfil per gestionar funcions com modificar nom, canviar idioma (català/castellà), indicar gènere, consultar estat de subscripció, activar/desactivar recordatoris diaris (notificacions push), enviar feedback, accedir als termes i condicions i tancar sessió.

### 14.2.- Procés de subscripció
1. L'usuari realitza el seu registre de forma gratuïta.
2. Disposa de 7 dies de prova gratuïta amb accés complet.
3. Si desitja continuar, accedeix a la secció "Subscripció" dins de l'app.
4. Selecciona el pla desitjat (mensual o anual).
5. És redirigit a la passarel·la de pagament segura de Stripe.
6. Introdueix les dades de la seva targeta.
7. Confirmació de pagament.
8. Recepció de confirmació per pantalla (l'accés continua actiu).
9. Renovació automàtica segons el pla escollit.

## 15è.- Tipus de productes

ESSENC·IA ofereix un únic producte: **Subscripció a una aplicació web d'autoconeixement emocional amb intel·ligència artificial**. Inclou:

- Accés a 30 lliçons d'autoconeixement emocional
- 30 exercicis pràctics amb feedback personalitzat
- Xat intel·ligent amb IA (text i àudio)
- Diari emocional amb reflexions setmanals
- Seguiment del "Sentir del dia" amb anàlisi emocional

**Modalitats de subscripció:**

- **Mensual**: 9,99 €/mes (EARLY BIRD: 7,99 €/mes)
- **Anual**: 99 €/any (EARLY BIRD: 79 €/any)

\\* Ambdues modalitats inclouen **7 dies de prova gratuïta**.

## 16è.- Subscripció màxima

Només és possible realitzar una subscripció per usuari.

## 17è.- Com ampliar o cancel·lar la subscripció

L'usuari pot ampliar la seva subscripció des del menú de configuració del seu perfil.

L'usuari pot cancel·lar la seva subscripció en qualsevol moment des del seu perfil dins de l'app. La cancel·lació es farà efectiva al final del període facturat actual. **No existeixen despeses addicionals per cancel·lar**.

## 18è.- Despeses i formes d'enviament

En tractar-se d'un servei digital, no hi ha enviaments físics ni despeses d'enviament.

## 19è.- Termini de lliurament

L'accés per a l'ús i gaudi del nostre producte és **immediat**, un cop realitzat el registre d'usuari i confirmat el pagament de la subscripció.

## 20è.- Factura

La facturació es gestiona mitjançant **Stripe**. L'usuari rep justificant de cada pagament/cobrament mitjançant email i pot gestionar les seves factures des del portal de Stripe.

## 21è.- IVA

De conformitat amb la normativa vigent, tota subscripció efectuada estarà subjecta a l'Impost sobre el Valor Afegit (IVA).

## 22è.- Mètodes o modalitats de pagament

L'Usuari podrà realitzar el pagament mitjançant **targeta de crèdit/dèbit**, facilitant entre altres: nom i cognoms, número de targeta, CVV/CVC i data de caducitat.

Si la plataforma de pagament denega la targeta, es cancel·larà automàticament la subscripció. **No s'admet pagament contra reemborsament**.

Les dades de la targeta **no es guarden** a la nostra base de dades; s'emplenen a la web segura de l'entitat bancària.

## 23è.- Disposicions generals sobre el procés de pagament

- L'ordre de pagament implica l'adhesió a aquestes Condicions Generals.
- Tots els pagaments estan subjectes als termes i condicions de les plataformes de pagament (Visa, Mastercard, etc.).
- Un cop efectuat correctament el pagament, l'Usuari rep confirmació en pantalla.
- El Prestador es reserva el dret de cancel·lar pagaments si hi ha indicis d'operacions fraudulentes.

## 24è.- Dret de desistiment

En tractar-se d'un servei de contingut digital:

- L'usuari podrà **cancel·lar sense cost** durant els 7 dies de prova gratuïta.
- Un cop iniciada la subscripció de pagament, l'usuari podrà cancel·lar en qualsevol moment, **sense dret a reemborsament** del període en curs. La cancel·lació es farà efectiva al final del període facturat.

Per sol·licitar la cancel·lació, l'usuari ha d'accedir al seu perfil dins de l'app. No existeixen costos addicionals per cancel·lar.

## 25è.- Excepcions al dret de desistiment

El dret de desistiment no aplica a la prestació de contingut digital quan l'execució hagi començat amb el consentiment previ de l'usuari i aquest hagi manifestat el seu coneixement que, en conseqüència, perd el seu dret de desistiment.

## 26è.- Atenció al client

Posem a disposició dels nostres usuaris els canals oficials següents:

- **Correu electrònic**: hola@essencia-app.com
- **Formulari de feedback integrat** dins de l'aplicació (botó flotant)

Horari d'atenció al client: de **dilluns a divendres**, de **9:00 a 18:00 h** (hora peninsular). Les consultes rebudes es processaran amb la major brevetat possible. Si es reben en dies no laborables, es processaran el següent dia hàbil.

## 27è.- Garantia dels productes

La garantia es correspon a la prestació efectiva del servei. L'usuari té dret a un servei funcional durant tot el període de subscripció activa. Si presenta errors tècnics, l'equip es compromet a solventar-los amb la major brevetat possible. Per a qualsevol incidència, l'usuari pot contactar a **hola@essencia-app.com**.

## 28è.- Drets del Prestador

- Conservar, modificar o suspendre la web sense avís previ.
- Modificar el preu de les ofertes.
- Rebutjar subscripció per impagament del client.
- Rebutjar l'accés a les eines informàtiques en cas d'incompliment d'aquestes condicions.
- Percebre l'import de la subscripció del client.
- Reservar-se el domini i conservar la propietat de l'article fins al pagament íntegre.
- Procedir a corregir errors humans o informàtics.

## 29è.- Limitació de responsabilitat

Tota la informació facilitada per l'Usuari haurà de ser veraç. El Prestador s'eximeix de qualsevol responsabilitat per danys causats com a conseqüència d'informació falsa, insuficient, inexacta o incorrecta.

El Prestador no serà responsable en els casos en què correspongui als pares, tutors o representants legals dels usuaris menors d'edat o incapacitats autoritzar l'accés, subministrament de informació personal o utilització del lloc.

El Prestador no respondrà per interrupcions en els serveis elèctrics o de telecomunicacions que impedeixin als usuaris utilitzar els serveis oferts.

## 30è.- Requisits d'ús

L'usuari declara i garanteix que:

- És **major de 18 anys** o disposa del consentiment del seu tutor legal.
- Té plena capacitat legal per acceptar aquests Termes.
- La informació proporcionada durant el registre és veraç i completa.

L'Aplicació **no està dirigida a menors de 18 anys**. Si tenim coneixement que un menor està utilitzant el Servei sense consentiment parental, procedirem a eliminar el seu compte.

## 31è.- Naturalesa del servei — Exoneració de responsabilitat

**ESSENC·IA és una eina d'autoconeixement i reflexió personal**. En cap cas constitueix:

- Un servei de teràpia psicològica o psiquiàtrica
- Un tractament mèdic o sanitari
- Un substitut de l'assessorament professional de salut mental
- Un servei d'emergències o atenció en crisi

La Titular, Cristina Bayés, i l'equip d'ESSENC·IA **NO són responsables** de:

- Les decisions que l'usuari prengui basant-se en el contingut de l'Aplicació.
- L'ús que l'usuari faci de les eines, lliçons, exercicis o respostes del xat amb IA.
- Qualsevol dany directe, indirecte, incidental o conseqüencial derivat de l'ús del Servei.
- La interpretació personal que l'usuari faci del contingut ofert.

L'usuari reconeix i accepta que:

- Utilitza l'Aplicació sota la seva pròpia responsabilitat.
- El contingut de l'Aplicació és de caràcter **educatiu i reflexiu, no terapèutic**.
- Les respostes generades per la intel·ligència artificial són **orientatives** i no substitueixen el criteri professional.
- En cas de patir una crisi emocional, un trastorn de salut mental o qualsevol situació d'emergència, ha de contactar amb un professional de la salut o els serveis d'emergència corresponents.

## 32è.- Llei aplicable i jurisdicció

Aquestes condicions es regiran o interpretaran segons la legislació espanyola. El prestador i l'usuari acorden sotmetre qualsevol controvèrsia als Jutjats i Tribunals del domicili de l'usuari. Si l'usuari té domicili fora d'Espanya, ambdues parts renuncien a qualsevol altre fur i se sotmeten als del domicili del PROPIETARI.

## 33è.- Resolució de litigis i mètodes alternatius

De conformitat amb la legislació de consum vigent a Espanya i la Unió Europea, informem als nostres clients que, en cas de conflicte, poden acudir a mecanismes alternatius de resolució de litigis (RAL), imparcials i extrajudicials.

A partir del 20 de juliol de 2025, la Plataforma de Resolució de Litigis en Línia (ODR) de la Comissió Europea va deixar d'estar operativa. No obstant, segueixen disponibles altres mètodes alternatius:

**Mètodes disponibles a Espanya:**

- **Centres de Resolució Alternativa de Litigis** acreditats per la Unió Europea, disponibles a través del Ministeri de Consum: [https://www.consumo.gob.es](https://www.consumo.gob.es)
- **Juntes Arbitrals de Consum**, disponibles per resoldre de forma gratuïta reclamacions amb empreses adherides al sistema: [https://www.portalconsumo.es/arbitraje](https://www.portalconsumo.es/arbitraje)
- **Centre Europeu del Consumidor a Espanya** (CEC Espanya), per a reclamacions transfrontereres dins de la UE: [https://cec.consumo.gob.es](https://cec.consumo.gob.es)

També pots acudir a:

- Oficines Municipals i Autonòmiques d'Informació al Consumidor (OMIC/OCIC).
- Organismes de Mediació sectorial segons l'activitat (energia, telecomunicacions, assegurances, transport, etc.).
`
    },
    es: {
      title: "Condiciones Generales de Contratación",
      lastUpdated: "Última actualización: mayo 2026",
      pdf: PDF_LINKS.terms,
      content: `
## 1º.- Marco legal

En cumplimiento de la normativa vigente, la entidad CRISTINA BAYÉS ESPINET que opera a través de internet desde el presente sitio ESSENCIA-APP.COM detalla a continuación las condiciones generales de contratación de los productos y/o servicios ofertados y de los que se generan los derechos y obligaciones de las partes.

## 2º.- Identificación

Las presentes Condiciones Generales de Contratación (en adelante, "Condiciones") tienen por función regular la relación entre CRISTINA BAYÉS ESPINET (en adelante, el "Prestador") y los clientes (en adelante, el "Usuario"), relativas a todas las transacciones realizadas a través de este portal online.

### 2.1.- Empresa Oferente

- **Denominación**: CRISTINA BAYÉS ESPINET
- **Nombre comercial**: ESSENC·IA
- **NIF**: 33951406W
- **Domicilio**: PASSATGE SERAFINS Nº 16 1º PISO
- **Población**: ARBUCIES
- **Provincia**: GIRONA
- **C.P.**: 17401
- **Teléfono**: 648 89 43 50
- **Correo electrónico**: hola@essencia-app.com

### 2.2.- El Usuario

Se entenderá por usuario o cliente el internauta que adquiere esa condición mediante su registro en el sitio, utilizando un formulario y al que se le asignan unas claves de usuario y contraseña. El usuario es responsable de su custodia y de la veracidad de los datos personales facilitados.

## 3º.- Aceptación

Mediante la aceptación de las presentes Condiciones, el Usuario declara:

1. Que es una persona con capacidad para contratar según la normativa vigente.
2. Que ha leído y acepta las presentes Condiciones.

## 4º.- Disponibilidad

El Usuario tendrá acceso siempre, con carácter previo al inicio del procedimiento de contratación, a las condiciones, pudiendo ser almacenadas y/o reproducidas en un soporte duradero.

## 5º.- Validez o duración

El periodo de validez de las presentes Condiciones será el tiempo que las mismas permanezcan publicadas en el sitio y resultarán de aplicación desde el momento en que el Usuario haga uso del sitio y/o proceda a la contratación/suscripción del producto.

## 6º.- Modificaciones

El prestador se reserva el derecho de modificar unilateralmente dichas Condiciones, sin que ello pueda afectar a los bienes o promociones adquiridos previamente a la modificación por parte del Usuario.

El Usuario se compromete a leer atentamente las condiciones de contratación cada vez que proceda a la contratación de algún producto, dado que pueden haber sido modificadas.

## 7º.- Nulidad

Si cualquier cláusula incluida en estas Condiciones fuese declarada total o parcialmente nula o ineficaz, tal nulidad afectará tan sólo a dicha disposición, subsistiendo en todo lo demás las Condiciones.

## 8º.- Objeto del contrato

El presente contrato tiene por objeto regular la relación contractual de compraventa nacida entre el prestador y el usuario en el momento en que éste acepta la compra durante el proceso de contratación online.

La relación contractual de suscripción conlleva el acceso a un producto de autoconocimiento emocional con inteligencia artificial, a cambio de un precio determinado y públicamente expuesto a través del sitio.

## 9º.- Registro de Usuarios

El Usuario podrá registrarse en essencia-app.com haciendo clic en "Crear Cuenta". Para ello, introducirá datos personales obligatorios (Nombre, Email, Contraseña (mínimo 6 caracteres), Idioma preferido). Seguidamente deberá aceptar los términos y condiciones y la política de privacidad, y de forma opcional la aceptación de envío de comunicaciones comerciales.

El usuario seleccionará un nombre de usuario y una contraseña, comprometiéndose a hacer uso diligente de los mismos y no ponerlos a disposición de terceros.

El usuario no podrá elegir como nombre de usuario palabras que puedan confundir a otros usuarios ni expresiones malsonantes, injuriosas o contrarias a la moral y buenas costumbres.

El sistema de registro envía un mensaje de bienvenida al email con un enlace de verificación que caduca en 24h. Seguidamente el usuario tiene acceso completo a la aplicación con un periodo de prueba gratuito de **7 días**.

## 10º.- Ámbito geográfico

ESSENCIA-APP.COM opera sin restricciones geográficas. La utilización de ESSENCIA-APP.COM se considera efectuada en España, sujeta a las leyes y normas españolas vigentes.

## 11º.- Información de productos

El Prestador pone gran atención a la información relativa a las características de su producto mediante descripciones detalladas de cada funcionalidad. El usuario tiene opción de explorar el contenido durante los 7 primeros días de prueba gratuita.

## 12º.- Impuestos, moneda

De conformidad con la normativa vigente, toda compra/suscripción estará sujeta al Impuesto sobre el Valor Añadido (IVA). Los precios incluyen el IVA y se expresan en euros (€).

## 13º.- Lengua del contrato

El procedimiento de contratación y la información precontractual están disponibles en **castellano y catalán**.

## 14º.- Pasos del proceso de contratación/suscripción

### 14.1.- Registro
Una vez registrado, el usuario puede entrar a su perfil para gestionar funciones como modificar nombre, cambiar idioma (catalán/castellano), indicar género, consultar estado de suscripción, activar/desactivar recordatorios diarios (notificaciones push), enviar feedback, acceder a los términos y condiciones y cerrar sesión.

### 14.2.- Proceso de suscripción
1. El usuario realiza su registro de forma gratuita.
2. Dispone de 7 días de prueba gratuita con acceso completo.
3. Si desea continuar, accede a la sección "Suscripción" dentro de la app.
4. Selecciona el plan deseado (mensual o anual).
5. Es redirigido a la pasarela de pago segura de Stripe.
6. Introduce los datos de su tarjeta.
7. Confirmación de pago.
8. Recepción de confirmación por pantalla (el acceso continúa activo).
9. Renovación automática según el plan escogido.

## 15º.- Tipos de productos

ESSENC·IA ofrece un único producto: **Suscripción a una aplicación web de autoconocimiento emocional con inteligencia artificial**. Incluye:

- Acceso a 30 lecciones de autoconocimiento emocional
- 30 ejercicios prácticos con feedback personalizado
- Chat inteligente con IA (texto y audio)
- Diario emocional con reflexiones semanales
- Seguimiento del "Sentir del día" con análisis emocional

**Modalidades de suscripción:**

- **Mensual**: 9,99 €/mes (EARLY BIRD: 7,99 €/mes)
- **Anual**: 99 €/año (EARLY BIRD: 79 €/año)

\\* Ambas modalidades incluyen **7 días de prueba gratuita**.

## 16º.- Suscripción máxima

Sólo es posible realizar una suscripción por usuario.

## 17º.- Cómo ampliar o cancelar la suscripción

El usuario puede ampliar su suscripción desde el menú de configuración de su perfil.

El usuario puede cancelar su suscripción en cualquier momento desde su perfil dentro de la App. La cancelación se hará efectiva al finalizar el periodo facturado actual. **No existen gastos adicionales por cancelar**.

## 18º.- Gastos y formas de envío

Al tratarse de un servicio digital, no existen envíos físicos ni gastos de envío.

## 19º.- Plazo de entrega

El acceso para uso y disfrute de nuestro producto es **inmediato**, una vez realizado el registro de usuario y confirmado el pago de la suscripción.

## 20º.- Factura

La facturación se gestiona mediante **Stripe**. El usuario recibe justificante de cada pago/cobro mediante email y puede gestionar sus facturas desde el portal de Stripe.

## 21º.- IVA

De conformidad con la normativa vigente, toda suscripción efectuada estará sujeta al Impuesto sobre el Valor Añadido (IVA).

## 22º.- Métodos o modalidades de pago

El Usuario podrá realizar el pago mediante **tarjeta de crédito/débito**, facilitando entre otros: nombre y apellidos, número de tarjeta, CVV/CVC y fecha de caducidad.

Si la plataforma de pago deniega la tarjeta, se cancelará automáticamente la suscripción. **No se admite el pago contra reembolso**.

Los datos de la tarjeta **no se guardan** en nuestra base de datos; se rellenan en la web segura de la entidad bancaria.

## 23º.- Disposiciones generales sobre el proceso de pago

- La orden de pago implica la adhesión a estas Condiciones Generales.
- Todos los pagos están sujetos a los términos y condiciones de las plataformas de pago (Visa, Mastercard, etc.).
- Una vez efectuado correctamente el pago, el Usuario recibe confirmación en pantalla.
- El Prestador se reserva el derecho de cancelar pagos si existen indicios de operaciones fraudulentas.

## 24º.- Derecho de desistimiento

Al tratarse de un servicio de contenido digital:

- El usuario podrá **cancelar sin coste** durante los 7 días de prueba gratuita.
- Una vez iniciada la suscripción de pago, el usuario podrá cancelar en cualquier momento, **sin derecho a reembolso** del periodo en curso. La cancelación se hará efectiva al final del periodo facturado.

Para solicitar la cancelación, el usuario debe acceder a su perfil dentro de la app. No existen costes adicionales por cancelar.

## 25º.- Excepciones al derecho de desistimiento

El derecho de desistimiento no aplica a la prestación de contenido digital cuando la ejecución haya comenzado con el consentimiento previo del usuario y éste haya manifestado su conocimiento de que, en consecuencia, pierde su derecho de desistimiento.

## 26º.- Atención al cliente

Ponemos a disposición de nuestros usuarios los siguientes canales oficiales:

- **Correo electrónico**: hola@essencia-app.com
- **Formulario de feedback integrado** dentro de la aplicación (botón flotante)

Horario de atención al cliente: de **lunes a viernes**, de **9:00 a 18:00 h** (hora peninsular). Las consultas recibidas se procesarán a la mayor brevedad posible. Si se reciben en días no laborables, se procesarán el siguiente día hábil.

## 27º.- Garantía de los productos

La garantía se corresponde a la prestación efectiva del servicio. El usuario tiene derecho a un servicio funcional durante todo el periodo de suscripción activa. Si presenta errores técnicos, el equipo se compromete a solventarlos a la mayor brevedad posible. Para cualquier incidencia, el usuario puede contactar en **hola@essencia-app.com**.

## 28º.- Derechos del Prestador

- Conservar, modificar o suspender su web sin previo aviso.
- Modificar el precio de las ofertas.
- Rechazar suscripción por impago del cliente.
- Rechazar el acceso a las herramientas informáticas en caso de incumplimiento de estas condiciones.
- Percibir el importe de la suscripción del cliente.
- Reservarse el dominio y conservar la propiedad del artículo hasta el íntegro pago.
- Proceder a corregir errores humanos o informáticos.

## 29º.- Limitación de responsabilidad

Toda la información facilitada por el Usuario deberá ser veraz. El Prestador se exime de cualquier responsabilidad por daños ocasionados como consecuencia de información falsa, insuficiente, inexacta o incorrecta.

El Prestador no será responsable en aquellos supuestos en los que corresponda a los padres, tutores o representantes legales de los Usuarios menores de edad o incapacitados autorizar el acceso, suministro de información personal o utilización del sitio.

El Prestador no responderá por las interrupciones que se produzcan en los servicios eléctricos o de telecomunicaciones que impidan a los usuarios utilizar los servicios ofrecidos.

## 30º.- Requisitos de uso

El usuario declara y garantiza que:

- Es **mayor de 18 años** o dispone del consentimiento de su tutor legal.
- Tiene plena capacidad legal para aceptar estos Términos.
- La información proporcionada durante el registro es veraz y completa.

La Aplicación **no está dirigida a menores de 18 años**. Si tenemos conocimiento de que un menor está utilizando el Servicio sin consentimiento parental, procederemos a eliminar su cuenta.

## 31º.- Naturaleza del servicio — Exoneración de responsabilidad

**ESSENC·IA es una herramienta de autoconocimiento y reflexión personal**. En ningún caso constituye:

- Un servicio de terapia psicológica o psiquiátrica
- Un tratamiento médico o sanitario
- Un sustituto del asesoramiento profesional de salud mental
- Un servicio de emergencias o atención en crisis

La Titular, Cristina Bayés, y el equipo de ESSENC·IA **NO son responsables** de:

- Las decisiones que el usuario tome basándose en el contenido de la Aplicación.
- El uso que el usuario haga de las herramientas, lecciones, ejercicios o respuestas del chat con IA.
- Cualquier daño directo, indirecto, incidental o consecuencial derivado del uso del Servicio.
- La interpretación personal que el usuario haga del contenido ofrecido.

El usuario reconoce y acepta que:

- Utiliza la Aplicación bajo su propia responsabilidad.
- El contenido de la Aplicación es de carácter **educativo y reflexivo, no terapéutico**.
- Las respuestas generadas por la inteligencia artificial son **orientativas** y no sustituyen el criterio profesional.
- En caso de sufrir una crisis emocional, un trastorno de salud mental o cualquier situación de emergencia, debe contactar con un profesional de la salud o los servicios de emergencia correspondientes.

## 32º.- Ley aplicable y jurisdicción

Estas condiciones se regirán o interpretarán conforme a la legislación española. El prestador y el usuario acuerdan someter cualquier controversia a los Juzgados y Tribunales del domicilio del usuario. Si el usuario tiene su domicilio fuera de España, ambas partes renuncian a cualquier otro fuero y se someten a los del domicilio del PROPIETARIO.

## 33º.- Resolución de litigios y métodos alternativos

De conformidad con la legislación de consumo vigente en España y la Unión Europea, informamos a nuestros clientes que, en caso de conflicto, pueden acudir a mecanismos alternativos de resolución de litigios (RAL), imparciales y extrajudiciales.

A partir del 20 de julio de 2025, la Plataforma de Resolución de Litigios en Línea (ODR) de la Comisión Europea dejó de estar operativa. No obstante, siguen disponibles otros métodos alternativos:

**Métodos disponibles en España:**

- **Centros de Resolución Alternativa de Litigios** acreditados por la Unión Europea, disponibles a través del Ministerio de Consumo: [https://www.consumo.gob.es](https://www.consumo.gob.es)
- **Juntas Arbitrales de Consumo**, disponibles para resolver de forma gratuita reclamaciones con empresas adheridas al sistema: [https://www.portalconsumo.es/arbitraje](https://www.portalconsumo.es/arbitraje)
- **Centro Europeo del Consumidor en España** (CEC España), para reclamaciones transfronterizas dentro de la UE: [https://cec.consumo.gob.es](https://cec.consumo.gob.es)

También puedes acudir a:

- Oficinas Municipales y Autonómicas de Información al Consumidor (OMIC/OCIC).
- Organismos de Mediación sectorial según la actividad (energía, telecomunicaciones, seguros, transporte, etc.).
`
    }
  }
};
